import "../../styles/global.css";
import React, { useState, useEffect } from "react";
import { fetchQuestionAverageByQuiz, fetchDemoQuestionAverage, 
         fetchAllSubmissionDates, fetchAllDemoSubmissionDates,
         fetchCourseSections } from "../../api/overviewApi";
import TrendChart from "./TrendChart";
import { Typography, Select, MenuItem } from "@mui/material";

const Trend = () => {

    const [sessionInfo, setSessionInfo] = useState(null);
    const [trendData, setTrendData] = useState({});
    const [selectedSection, setSelectedSection] = useState("all");  
    const [sectionNumbers, setSectionNumbers] = useState([]);        

    useEffect(() => {
        const cached = localStorage.getItem('iTOOLS_sessionInfo');
        if (cached) {
            console.log("Using cached session info");
            setSessionInfo(JSON.parse(cached));
        } else {
            console.log("No cached session info found");
            setSessionInfo({ name: "Demo Course" }); // Fallback to demo
        }
    }, []);

    useEffect(() => {
        if (!sessionInfo?.courseId) return;
        fetchCourseSections(sessionInfo.courseId)
            .then((data) => setSectionNumbers(data.sections ?? []))
            .catch((err) => console.error("Error fetching course sections:", err));
    }, [sessionInfo]);

    useEffect(() => {
        if (!sessionInfo) return;

        const fetchAverage = sessionInfo.courseId
            ? () => fetchQuestionAverageByQuiz(sessionInfo.courseId, selectedSection)
            : () => fetchDemoQuestionAverage();

        fetchAverage()
            .then((data) => {
                setTrendData(data);
            })
            .catch((error) => {
                console.error("Error fetching trend data:", error);
            });
    }, [sessionInfo, selectedSection]);

    console.log("Trend - trendData:", trendData);
    return (
        <div className="wrapper">
            <div style={{ display: "flex", alignItems: "center", gap: "1.5rem", flexWrap: "wrap", marginBottom: "1rem" }}>
                <h1 className="title" style={{ margin: 0 }}>CLASS TRENDS OVER TIME</h1>
                {sectionNumbers.length > 0 && (
                    <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
                        <Typography variant="subtitle1"><strong>Filter by:</strong></Typography>
                        <Select
                            value={selectedSection}
                            onChange={(e) => setSelectedSection(e.target.value)}
                            size="small"
                            style={{ minWidth: 160 }}
                        >
                            <MenuItem value="all">All Sections</MenuItem>
                            {sectionNumbers.map((sec) => (
                                <MenuItem key={sec} value={sec}>Section {sec}</MenuItem>
                            ))}
                        </Select>
                    </div>
                )}
            </div>
            <p>The trend chart below show changes in each measure collected through the reflection surveys. X-axis represent the submitted date of the surveys. You can click on each measure’s legend to mute or unmute it. Hover over a data point to see the exact score. Note that the frequency of data collection varies.</p>
            {trendData.length > 0 ? (
              <TrendChart trendData={trendData} />
            ) : (
              <p className="muted-text">Survey data will populate once the quiz becomes available.</p>
            )}
        </div>
    );
};

export default Trend;